import { TagEnum } from "../../ctf/enums/tag.enum";

export class GetCtfAdminAction {
  static readonly type = "[ADMIN] Get Ctf";
}

export class GetSelectedCtfAdminAction {
  static readonly type = "[ADMIN] Get Selected Ctf";
  constructor(public id: number) {}
}

export class FilterCtfAdminAction {
  static readonly type = "[ADMIN] Filter Ctf";

  constructor(
    public filter: { type?: TagEnum | null; difficulty?: number | null ; search?: string | null },
  ) {}
}

export class GetAllIssuesAction {
  static readonly type = "[ADMIN] Get All Issues";
}

export class GetIssuesByEnigmeIdAction {
  static readonly type = "[ADMIN] Get Issues By Enigme Id";
  constructor(public enigmeId: number) {}
}

export class DeleteIssueAction {
  static readonly type = "[ADMIN] Delete Issue";
  constructor(public issueId: number, public enigmeId: number) {}
}
